import { useQuery } from '@tanstack/react-query';
import { subscriptionApi } from '../lib/api';
import { useAuthStore } from '../store/authStore';

export function useFeatureAccess() {
  const { user } = useAuthStore();

  const { data: features } = useQuery({
    queryKey: ['subscription-features'],
    queryFn: async () => {
      const response = await subscriptionApi.getFeatures();
      return response.data;
    },
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // 5 minutes — avoid constant refetches
    gcTime: 10 * 60 * 1000,
  });

  const hasFeature = (featureId: string): boolean => {
    // Assume access while loading to prevent "Feature Locked" flash
    if (!features) return true;
    return features.features.some((f: any) => f.id === featureId && f.enabled);
  };

  const getPlan = (): string => {
    return features?.plan || user?.subscriptionPlan || 'PROFESSIONAL';
  };

  return {
    hasFeature,
    getPlan,
    features: features?.features || [],
    isLoading: !features,
  };
}
